// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-navigation-drawer__border {\n    display: none;\n}\n.slide-leave-active {\n    transition: 0.1s;\n    opacity: 0;\n}\n.slide-enter-active {\n    transition: 0.9s;\n    opacity: 1;\n}\n.slide-enter {\n    transform: translateY(100%);\n}\n.slide-leave-to {\n    transform: translateY(50%);\n}\n", ""]);
// Exports
module.exports = exports;
